import type { ReactNode } from 'react'

import estilos from './Cartao.module.css'

export function Cartao({
  titulo,
  subtitulo,
  acoes,
  children,
}: {
  titulo?: ReactNode
  subtitulo?: ReactNode
  acoes?: ReactNode
  children: ReactNode
}) {
  return (
    <section className={estilos.cartao}>
      {(titulo || acoes) && (
        <header className={estilos.cabecalho}>
          <div className={estilos.titulos}>
            {titulo && <h2 className={estilos.titulo}>{titulo}</h2>}
            {subtitulo && <p className={estilos.subtitulo}>{subtitulo}</p>}
          </div>
          {acoes && <div className={estilos.acoes}>{acoes}</div>}
        </header>
      )}
      {children}
    </section>
  )
}

/**
 * Stat tile.
 *
 * A forma certa quando a resposta é um número — e boa parte do painel do R era
 * um gráfico de uma barra só fazendo o trabalho de um número.
 *
 * Sem `tabular-nums`: em corpo grande, dígitos de largura fixa fazem `121`
 * parecer frouxo. A alinhamento vertical importa na tabela, não aqui.
 */
export function Tile({
  rotulo,
  valor,
  nota,
  tom = 'neutro',
}: {
  rotulo: string
  valor: ReactNode
  nota?: ReactNode
  tom?: 'neutro' | 'bom' | 'critico'
}) {
  return (
    <div className={estilos.tile}>
      <span className={estilos.tileRotulo}>{rotulo}</span>
      <strong className={`${estilos.tileValor} ${estilos[tom]}`}>{valor}</strong>
      {nota && <span className={estilos.tileNota}>{nota}</span>}
    </div>
  )
}

export function Tiles({ children }: { children: ReactNode }) {
  return <div className={estilos.tiles}>{children}</div>
}
